import { render, staticRenderFns } from "./banner-pro.vue?vue&type=template&id=95003a38&"
import script from "./banner-pro.vue?vue&type=script&lang=js&"
export * from "./banner-pro.vue?vue&type=script&lang=js&"
import style0 from "./banner-pro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports